// Just imports core.js
import '../../../core/assets/_components/main.js'; // Inherit core main.js



// WEBPACK FOOTER //
// ./src/swe/assets/_components/main.js